<template>
    <div class="user-edit">
        <h2 class="page-title">Country                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    - <span class="fw-semi-bold">Detail</span></h2>
        <Widget :title="(isNew ? 'New' : 'Edit') + ' country'">
            <Loader v-if="!isNew && isReceiving" :size="40"></Loader>
            <Form v-else>
                <div class="form-group row">
                    <label class="col-md-2" for="name">Country name</label>
                    <div class="col-md-5">
                        <input class="form-control" id="name" type="text" :value="country.name" @change="updateCountryProperty($event, 'name')"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-2" for="code">Country code</label>
                    <div class="col-md-5">
                        <input class="form-control" id="code" type="text" :value="country.code" @change="updateCountryProperty($event, 'code')"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-2" for="code">AD code</label>
                    <div class="col-md-5">
                        <input class="form-control" id="ADCode" type="text" :value="country.adCode" @change="updateCountryProperty($event, 'adCode')"/>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-2" for="timezone">Timezone</label>
                    <div class="col-md-5">
                        <v-select
                            id="timezone"
                            v-model="country.timezone"
                            :options="getTimezoneOptions()"
                        />
                    </div>
                </div>
                <b-alert class="alert-sm w-25" variant="danger" :show="errorsList.length > 0" :key="error"
                         v-for="error in errorsList">
                    {{error}}
                </b-alert>
                <b-button-toolbar>
                    <b-button variant="success"
                              @click="saveCountry()">
                        <Loader v-if="isUpdating"></Loader>
                        <span v-else>Save</span>
                    </b-button>

                    <b-button variant="default" @click="goBack()">
                        Back
                    </b-button>

                </b-button-toolbar>
            </Form>
        </Widget>
    </div>
</template>


<script>
  import {mapActions, mapState} from "vuex";
  import moment from "moment-timezone";
  import {firestore} from "../../../main";
  import Loader from "../../../components/Loader/Loader";
  import vSelect from "vue-select";


  export default {
    name: "AddCountry",
    components: { Loader, vSelect },
    data(){
      return {
        showAddCountry: false,
        errorsList: []
      }
    },
    computed: {
      ...mapState("countries", ["countries", "isReceiving", "isUpdating"]),
      isNew() { return this.getId() === -1},
      country() {
        return this.findCountry(this.getId()) || {}
      }
    },
    methods: {
      ...mapActions("countries", ["createCountryRequest", "getCountriesRequest", "updateCountryRequest"]),
      async saveCountry(){
        this.errorsList = [];

        if(this.country.name == null){
          this.errorsList.push('Country name is required!')
        }
        if(this.country.code == null){
          this.errorsList.push('Country code is required!')
        }
        if(this.country.adCode == null){
          this.errorsList.push('AD code is required!')
        }
        if(this.country.timezone == null){
          this.errorsList.push('Timezone is required!')
        }

        const existingCountryWithSameCode = await firestore.collection('countries')
          .where("code", "==", this.country.code).get()
        const existingCountryWithSameADCode = await firestore.collection('countries')
          .where("adCode", "==", this.country.adCode).get()
        if(this.isNew && existingCountryWithSameCode.docs.length > 0){
          this.errorsList.push('Country code must be unique!')
        } else if (!this.isNew && existingCountryWithSameCode.docs.length > 0){
          const existingCountry = existingCountryWithSameCode.docs[0]
          if(existingCountry.id != this.country.id){
            this.errorsList.push('Country code must be unique!')
          }
        }

        if(this.isNew && existingCountryWithSameADCode.docs.length > 0){
          this.errorsList.push('AD code must be unique!')
        } else if (!this.isNew && existingCountryWithSameADCode.docs.length > 0){
          const existingCountry = existingCountryWithSameADCode.docs[0]
          if(existingCountry.id != this.country.id){
            this.errorsList.push('AD code must be unique!')
          }
        }

        if(this.errorsList.length == 0) {
          if(this.isNew) {
            await this.createCountryRequest({
              country: {
                name: this.country.name,
                code: this.country.code,
                adCode: this.country.adCode,
                timezone: this.country.timezone
              },
              $toasted: this.$toasted
            })
          } else {
            await this.updateCountryRequest({
              id: this.country.id,
              country: {
                name: this.country.name,
                code: this.country.code,
                adCode: this.country.adCode,
                timezone: this.country.timezone
              },
              $toasted: this.$toasted
            })
          }
        }
      },
      findCountry(id) {
        let country = this.countries ? this.countries.find(c => c.id === id) : null
        return country;
      },
      getId() {
        return this.$route.params.id || -1;
      },
      updateCountryProperty(value, key) {
        let country = this.country;

        country[key] = value.target.value;
      },
      goBack() {
        this.$router.replace('/app/admin-console/countries');
      },
      getTimezoneOptions(){
          return moment.tz.names();
      },
    },
    async mounted() {
      await this.getCountriesRequest();

    }
  }
</script>

<style src="./AddCountry.scss" lang="scss">

</style>
